/**
 * @name vg dropdown
 * @copyright by vegas s.
 * @date: 03.04.2020
 * @last-update: 08.10.2020
 * @version  1.5
 *
 */
window.vgDropdown = {
	container: '.vg-dropdown',
	content: '.vg-dropdown-content',
	setting: null,
	defaults: {
		hard_placement: false,
		offset: 0
	},

	init: function ($self) {
		let data = $self.data();

		this.setting = $.extend(this.setting, this.defaults, data);
		this.setParams($self);
		this.setting = {};
	},
	setParams: function ($self) {
		let $container = $self.closest(this.container),
			$drop = $container.find(this.content);

		$self.attr('area-expanded', false);

		if ('width' in this.setting) {
			$drop.css('width', parseInt(this.setting.width))
		}
	},
	open: function ($self) {
		let $container = $self.closest(this.container),
			$drop = $container.find(this.content),
			$drops = $('body').find(this.content);

		if ($drop.hasClass('show')) {
			$container.removeClass('active');
			this.close(false, $drop, $self)
		} else {
			if ($drops.length) {
				$drops.each(function () {
					vgDropdown.close(false, $(this));
				});
			}

			$container.addClass('active');
			$drop.addClass('show');
			$self.attr('area-expanded', true);
		}
	},

	close: function (e, $drop, $self = false) {
		const $container = $(this.container);

		if (!$self && $drop) {
			$self = $drop.closest(this.container).find('[data-toggle]');
		}

		if ($drop && $drop.length) {
			return closer($drop, $self);
		} else {
			let $toggle = $container.find('[data-toggle]');

			if ($container.has(e.target).length === 0) {
				return closer($container.find(this.content), $toggle);
			}
		}

		function closer(drop, toggle) {
			drop.removeClass('show');
			$container.removeClass('active');
			toggle.attr('area-expanded', false);
			return false;
		}
	},
};

$(document).ready(function () {
	$('[data-toggle=vg-dropdown]').each(function () {
		vgDropdown.init($(this));
	});
});

$(document).on('click', '[data-toggle=vg-dropdown]', function () {
	vgDropdown.open($(this));

	return false;
});

$(document).on('click', '[data-dismiss=vg-dropdown]', function (e) {
	vgDropdown.close(e, $(this).closest(vgDropdown.container).find(vgDropdown.content));

	return false;
});

$(document).mouseup(function (e) {
	vgDropdown.close(e);

	return true;
});
